var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.31 9.00247L17.7077 1.64516C18.0624 1.29408 18.0624 0.72572 17.7077 0.375543C17.354 0.0244677 16.7793 0.0244677 16.4255 0.375543L9.03412 7.72657L1.57445 0.266C1.22068 -0.0886666 0.646032 -0.0886666 0.292263 0.266C-0.0615053 0.621564 -0.0615053 1.19711 0.292263 1.55178L7.74655 9.00696L0.265326 16.4469C-0.0884422 16.798 -0.0884422 17.3663 0.265326 17.7165C0.619095 18.0676 1.19374 18.0676 1.54751 17.7165L9.02245 10.2829L16.4525 17.7138C16.8063 18.0685 17.3809 18.0685 17.7347 17.7138C18.0884 17.3582 18.0884 16.7827 17.7347 16.428L10.31 9.00247Z",
    fill: "#121313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.81a6fc4e6e93f43ff1ebe67eefedad78.svg";
export { ForwardRef as ReactComponent };